var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUnSelectedAdminIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "eos-icons:admin"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0.833984L2.5 4.16732V9.16732C2.5 13.7923 5.7 18.1173 10 19.1673C14.3 18.1173 17.5 13.7923 17.5 9.16732V4.16732L10 0.833984ZM10 4.08398C10.4945 4.08398 10.9778 4.23061 11.3889 4.50531C11.8 4.78001 12.1205 5.17046 12.3097 5.62728C12.4989 6.08409 12.5484 6.58676 12.452 7.07171C12.3555 7.55666 12.1174 8.00212 11.7678 8.35175C11.4181 8.70138 10.9727 8.93948 10.4877 9.03595C10.0028 9.13241 9.50011 9.0829 9.04329 8.89368C8.58648 8.70446 8.19603 8.38403 7.92133 7.97291C7.64662 7.56179 7.5 7.07844 7.5 6.58398C7.5 5.92094 7.76339 5.28506 8.23223 4.81622C8.70107 4.34738 9.33696 4.08398 10 4.08398ZM10 10.6673C11.6667 10.6673 15 11.5757 15 13.234C14.4527 14.0591 13.7097 14.7359 12.8373 15.2041C11.9649 15.6723 10.9901 15.9174 10 15.9174C9.00988 15.9174 8.03515 15.6723 7.16273 15.2041C6.2903 14.7359 5.54731 14.0591 5 13.234C5 11.5757 8.33333 10.6673 10 10.6673Z",
    fill: "#9999CD"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnSelectedAdminIcon);
export default __webpack_public_path__ + "static/media/unSelectedAdminIcon.a3716c919cc304d8315286e0d8d8732f.svg";
export { ForwardRef as ReactComponent };